<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">
    <div v-show="Isblur" class="splash"></div>

    <sidebar></sidebar>
    <!-- Jobs -->
    <div class="card-panel-main col-lg-9 mb-5" style="transform: translateX(-19vw)">
      <div class="row">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="row d-flex justify-content-start">
              <h2 style="font-size: 1.2vw !important; text-align: right">شناسایی نیازها وانتظارات ذینفعان</h2>
            </div>
            <div style="padding: 4vw 2vw">
              <div class="card card-body card-panel-box card-beneficiary-orderby border-0">
                <h3 style="font-size: 0.9vw !important;font-weight: 700;margin-right: 1vw;color: #fff;">نمایش بر اساس</h3>
                <div class="row">
                  <div class="col-lg-4">
                    <div class="card card-body card-panel-box card-beneficiary-orderby-item active border-0">
                      <h3 class="mb-4">ذی نفع</h3>
                      <div class="col-lg-12 mb-4">
                        <select class="form-select" name="" required>
                          <option value="">انتخاب ذی نفع</option>
                          <option value="Dallas">1</option>
                          <option value="Houston">2</option>
                          <option value="Los Angeles">3</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="card card-body card-panel-box card-beneficiary-orderby-item border-0">
                      <h3 class="mb-4">فرآیند</h3>
                      <div class="col-lg-12 mb-4">
                        <select class="form-select" name="" required>
                          <option value="">انتخاب فرآیند</option>
                          <option value="Dallas">1</option>
                          <option value="Houston">2</option>
                          <option value="Los Angeles">3</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <div class="card card-body card-panel-box card-beneficiary-orderby-item border-0">
                      <h3 class="mb-4">زیر فرآیند</h3>
                      <div class="col-lg-12 mb-4">
                        <select class="form-select" name="" required>
                          <option value="">انتخاب پست سازمانی</option>
                          <option value="Dallas">1</option>
                          <option value="Houston">2</option>
                          <option value="Los Angeles">3</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="form-buttons row mt-5 d-flex justify-content-center">
                  <button class="btn btn-primary btn-submit-1 m-2" type="submit">نمایش</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
export default {
  name: "beneficiary_id_order_by",
  components: {Sidebar, Splash}
}
</script>

<style scoped>
.row{
  padding: .5vw;
}
</style>